import { useMemo, type ReactNode } from 'react';
import { Icon, Tooltip } from '@ics-portal/guardian';
import { type NavigationItem } from '@models/Navigation';

/**
 * Get the icon for a navigation item
 * @param item
 * @param isActive
 * @param sidebarIsCollapsed
 * @returns ReactNode
 */
interface NavigationItemIconProps {
    item: NavigationItem;
    isActive?: boolean;
    sidebarIsCollapsed?: boolean;
    isSubmenuItem?: boolean;
}

export default function NavigationItemIcon({
    item,
    sidebarIsCollapsed,
    isSubmenuItem,
}: NavigationItemIconProps): ReactNode {
    const formattedLabel = item.label
        .replace(/\s+/g, '-')
        .replace(/\/+/g, '-')
        .toLowerCase();
    const id = `navigation-${CSS.escape(formattedLabel)}`;

    const tooltipContent = useMemo(
        () => (sidebarIsCollapsed ? item.label : ''),
        [item.label, sidebarIsCollapsed],
    );

    return (
        <>
            <Tooltip target={`#${id}`} />
            <div id={id} className="flex align-items-center">
                {item.icon ? (
                    <Icon
                        name={item.icon}
                        fontSize={isSubmenuItem ? 'medium' : 'normal'}
                        data-pr-tooltip={tooltipContent}
                        data-pr-position="right"
                        style={{ zIndex: 10 }}
                    />
                ) : (
                    <span>{item.label.charAt(0).toUpperCase()}</span>
                )}
            </div>
        </>
    );
}
